import { cn } from '@sohanemon/utils';
import type { ComponentProps } from 'react';

type TelemetryRowsProps = ComponentProps<'dl'> & {
	params: { key: string; value: string }[];
};

export function TelemetryRows({
	params,
	className,
	...props
}: TelemetryRowsProps) {
	return (
		<dl className={cn('whitespace-normal', className)} {...props}>
			{params.map((t) => (
				<div
					key={t.key}
					className="flex items-baseline justify-between gap-4 not-first:border-border/20 not-first:border-t py-2 font-mono text-xs tabular-nums"
				>
					<dt className="shrink-0 text-muted-foreground">{t.key}</dt>
					<dd className="text-right text-primary">{t.value}</dd>
				</div>
			))}
		</dl>
	);
}
